import React, { useEffect, useRef } from 'react';

const VatRates = () => {
  const rateRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    rateRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      rateRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const vatRates = [
    { region: 'Europe', countries: [
      { name: 'United Kingdom', rate: '20%', currency: '£' },
      { name: 'Germany', rate: '19%', currency: '€' },
      { name: 'France', rate: '20%', currency: '€' },
      { name: 'Italy', rate: '22%', currency: '€' },
      { name: 'Spain', rate: '21%', currency: '€' },
      { name: 'Netherlands', rate: '21%', currency: '€' },
      { name: 'Belgium', rate: '21%', currency: '€' },
      { name: 'Austria', rate: '20%', currency: '€' },
      { name: 'Poland', rate: '23%', currency: '€' },
      { name: 'Sweden', rate: '25%', currency: '€' },
      { name: 'Denmark', rate: '25%', currency: '€' },
      { name: 'Ireland', rate: '23%', currency: '€' },
      { name: 'Portugal', rate: '23%', currency: '€' },
      { name: 'Finland', rate: '24%', currency: '€' },
      { name: 'Greece', rate: '24%', currency: '€' },
      { name: 'Czech Republic', rate: '21%', currency: '€' },
      { name: 'Romania', rate: '19%', currency: '€' },
      { name: 'Hungary', rate: '27%', currency: '€' },
      { name: 'Bulgaria', rate: '20%', currency: '€' },
      { name: 'Switzerland', rate: '7.7%', currency: '₣' },
      { name: 'Norway', rate: '25%', currency: '€' }
    ]},
    { region: 'Americas', countries: [
      { name: 'United States', rate: '0%', currency: '$' },
      { name: 'Canada', rate: '5-15%', currency: 'C$' },
      { name: 'Brazil', rate: '18%', currency: 'R$' },
      { name: 'Mexico', rate: '16%', currency: 'MX$' },
      { name: 'Argentina', rate: '21%', currency: 'ARS' },
      { name: 'Chile', rate: '19%', currency: 'CLP' },
      { name: 'Colombia', rate: '19%', currency: 'COP' },
      { name: 'Peru', rate: '18%', currency: 'PEN' }
    ]},
    { region: 'Asia Pacific', countries: [
      { name: 'Australia', rate: '10%', currency: 'A$' },
      { name: 'New Zealand', rate: '15%', currency: 'NZ$' },
      { name: 'India', rate: '18%', currency: '₹' },
      { name: 'China', rate: '13%', currency: 'CN¥' },
      { name: 'Japan', rate: '10%', currency: '¥' },
      { name: 'South Korea', rate: '10%', currency: '₩' },
      { name: 'Singapore', rate: '9%', currency: 'S$' },
      { name: 'Malaysia', rate: '10%', currency: 'RM' },
      { name: 'Thailand', rate: '7%', currency: '฿' },
      { name: 'Philippines', rate: '12%', currency: '₱' },
      { name: 'Indonesia', rate: '11%', currency: 'Rp' },
      { name: 'Vietnam', rate: '10%', currency: '₫' },
      { name: 'Hong Kong', rate: '0%', currency: 'HK$' }
    ]},
    { region: 'Middle East & Africa', countries: [
      { name: 'UAE', rate: '5%', currency: 'د.إ' },
      { name: 'Saudi Arabia', rate: '15%', currency: 'SAR' },
      { name: 'Israel', rate: '17%', currency: '₪' },
      { name: 'South Africa', rate: '15%', currency: 'R' },
      { name: 'Nigeria', rate: '7.5%', currency: '₦' },
      { name: 'Egypt', rate: '14%', currency: 'EGP' },
      { name: 'Kenya', rate: '16%', currency: 'KES' }
    ]},
    { region: 'Other Regions', countries: [
      { name: 'Russia', rate: '20%', currency: '₽' },
      { name: 'Ukraine', rate: '20%', currency: '₴' },
      { name: 'Turkey', rate: '20%', currency: 'TRY' },
      { name: 'Pakistan', rate: '17%', currency: '₨' },
      { name: 'Bangladesh', rate: '15%', currency: 'BDT' }
    ]}
  ];

  return (
    <section className="vat-rates-section">
      <div className="vat-rates-container">
        <h2 className="section-title">VAT Rates in Different Countries</h2>
        <p className="section-subtitle">Comprehensive guide to VAT rates across major countries and regions</p>

        <div className="vat-rates-grid">
          {vatRates.map((region, regionIndex) => (
            <div
              key={region.region}
              className="vat-rate-region"
              ref={el => rateRefs.current[regionIndex] = el}
            >
              <h3 className="region-title">{region.region}</h3>
              <div className="countries-grid">
                {region.countries.map((country, countryIndex) => (
                  <div key={countryIndex} className="country-card">
                    <div className="country-name">{country.name}</div>
                    <div className="country-rate">{country.rate}</div>
                    <div className="country-currency">{country.currency}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VatRates;
